// extracted by mini-css-extract-plugin
module.exports = {"accordion_item":"style_accordion_item__AqPvr"};